import { 
  productsService, 
  categoriesService, 
  brandsService, 
  advertisementsService, 
  searchService 
} from './firebase';



// Products API
export const productsAPI = {
  getAll: async (filters = {}) => {
    try {
      const products = await productsService.getAll(filters);
      return { data: products };
    } catch (error) {
      console.error('Error fetching products:', error);
      return { data: [] };
    }
  },
  getById: async (id) => {
    try {
      const product = await productsService.getById(id);
      return { data: product };
    } catch (error) {
      console.error('Error fetching product:', error);
      return { data: null };
    }
  }
};

// Categories API
export const categoriesAPI = {
  getAll: async () => {
    try {
      const categories = await categoriesService.getAll();
      return { data: categories };
    } catch (error) {
      console.error('Error fetching categories:', error);
      return { data: [] };
    }
  }
};

// Brands API
export const brandsAPI = {
  getAll: async () => {
    try {
      const brands = await brandsService.getAll();
      return { data: brands };
    } catch (error) {
      console.error('Error fetching brands:', error);
      return { data: [] };
    }
  }
};

// Search API
export const searchAPI = {
  search: async (query) => {
    try {
      const products = await searchService.searchProducts(query);
      return { data: { products, searchTerm: query } };
    } catch (error) {
      console.error('Error searching products:', error);
      return { data: { products: [], searchTerm: query } };
    }
  },
  getSuggestions: async (query) => {
    try {
      const products = await searchService.searchProducts(query);
      const suggestions = products
        .slice(0, 5)
        .map(product => ({
          id: product.id,
          name: product.name,
          category: product.category,
          brand: product.brand
        }));
      return { data: suggestions };
    } catch (error) {
      console.error('Error getting search suggestions:', error);
      return { data: [] };
    }
  },
  getPopular: async () => {
    try {
      // Return empty array to avoid CORB issues completely
      return { data: [] };
    } catch (error) {
      console.error('Error getting popular products:', error);
      return { data: [] };
    }
  }
};


